import React from "react";

import { PostCreateEditForm, PostFormData } from "@/mk2/apps/forum/components/PostCreateEditForm";
import {
    CONTESTS_TOPIC_ID,
    COUNSELLING_CATEGORY_ID,
    TESTINGS_TOPIC_ID,
} from "@/mk2/apps/forum/constants";
import { Props } from "@/mk2/apps/forum/containers/PostCreate/PostCreatePage";
import { LoadingSwitch } from "@/mk2/containers/LoadingSwitch/LoadingSwitch";
import { isAuthenticated } from "@/mk/bazaar/common/userUtils";

import styles from "./PostCreate.mscss";

export default class PostCreate extends React.Component<Props> {
    public render() {
        const { loadingState, topic } = this.props;

        return (
            <div className={styles.PostCreate}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderLoadSuccess}
                    hasData={!!topic}
                />
            </div>
        );
    }

    private load = () => {
        const {
            onLoad,
            routeParams: { topicSlug },
        } = this.props;
        onLoad(topicSlug);
    };

    private renderLoadSuccess = () => {
        const {
            anonymousMode,
            wantsMkToFoundDiscussion,
            initialValues,
            isMobile,
            topic,
            requestUser,
            requestUserPermissions,
        } = this.props;

        const isUnauth = !isAuthenticated(requestUser);

        return topic.id === CONTESTS_TOPIC_ID ||
            topic.id === TESTINGS_TOPIC_ID ||
            topic.category.id === COUNSELLING_CATEGORY_ID ? null : (
            <PostCreateEditForm
                anonymousMode={anonymousMode}
                wantsMkToFoundDiscussion={wantsMkToFoundDiscussion}
                isMobile={isMobile}
                isUnauthenticatedUser={isUnauth}
                showTopic
                onSave={this.handleOnSave}
                onEnableAnonymousMode={this.enableAnonymousMode}
                onDisableAnonymousMode={this.disableAnonymousMode}
                onSetWantsMkToFoundDiscussion={this.setWantsMkToFoundDiscussion}
                initialValues={initialValues}
                requestUserPermissions={requestUserPermissions}
            />
        );
    };

    private enableAnonymousMode = () => {
        const {
            routeParams: { topicSlug },
            onSetAnonymousMode,
        } = this.props;
        onSetAnonymousMode(topicSlug, true);
    };

    private disableAnonymousMode = () => {
        const {
            routeParams: { topicSlug },
            onSetAnonymousMode,
        } = this.props;
        onSetAnonymousMode(topicSlug, false);
    };

    private setWantsMkToFoundDiscussion = (enabled: boolean) => {
        const {
            routeParams: { topicSlug },
            onSetWantsMkToFoundDiscussion,
        } = this.props;
        onSetWantsMkToFoundDiscussion(topicSlug, enabled);
    };

    private handleOnSave = (values: PostFormData) => {
        const {
            anonymousMode,
            onSave,
            onPendingActionCreate,
            requestUser,
            routeParams: { topicSlug },
        } = this.props;
        if (!isAuthenticated(requestUser)) {
            onPendingActionCreate(topicSlug, values);
        } else {
            onSave(topicSlug, anonymousMode, values);
        }
    };
}
